import type { HTMLAttributes } from 'react';
import { cn } from '../../shared/cn';

export function Badge({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return <span className={cn('inline-flex items-center rounded-full bg-[#eef3ea] px-2 py-0.5 text-xs font-medium text-[#4f5d49]', className)} {...props} />;
}
